module.exports = __webpack_public_path__ + "img/css.2def915d.svg";